var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoPlayerLimits = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_player_limits",
    "data-name": "ico player limits",
    d: "M110.682,904.32a3.549,3.549,0,1,1-3.39,3.545A3.47,3.47,0,0,1,110.682,904.32Zm1.479,11.135a5.41,5.41,0,0,1,1.167-3.364.976.976,0,0,0-.52.2,3.281,3.281,0,0,1-4.217-.02.928.928,0,0,0-.809-.189,6.171,6.171,0,0,0-3.731,5.339c-.092.833.346,2.864,6.614,2.894a16.687,16.687,0,0,0,3.886-.361,5.444,5.444,0,0,1-2.39-4.5ZM117.6,911a4.45,4.45,0,1,0,4.443,4.457v-.007A4.45,4.45,0,0,0,117.6,911Zm2.1,6.891a.522.522,0,0,1-.738,0l0,0-1.848-1.85a.52.52,0,0,1-.15-.384V913.03a.523.523,0,0,1,1.046-.005v2.433l1.7,1.7a.524.524,0,0,1-.005.737Z",
    transform: "translate(-104.041 -904.32)",
    fill: "#999"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoPlayerLimits);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_player_limits.6843da2d59c272d5ab3a3918c46b1636.svg";